import { joinChannel } from './ws-actions';

export const emitBlogOpened = () => joinChannel('blog');
